import { cn } from "@/lib/utils"

/**
 * Заглушка на время запроса. Пульсации нет — вместо неё короткий блик слева
 * направо: 100 мигающих строк на приборной панели читаются как авария.
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        "relative block overflow-hidden rounded-sm bg-surface-sunken",
        "after:absolute after:inset-0 after:animate-sweep after:bg-gradient-to-r after:from-transparent after:via-line/70 after:to-transparent after:content-['']",
        className,
      )}
    />
  )
}
